import { createSlice } from '@reduxjs/toolkit';
import { fetchAdvertisements, createAdvertisementPlay } from '../actions/advertisementsActions';

const initialState = {
    // { advertisements: [...], settings?: {...} } — как отдаёт сервер
    advertisements: null,
    // Локальные адреса файлов из кэша Electron: { [version]: "pbad://media/…" }
    media: {},
    loading: false,
    error: null,
    playLoading: false, // Для отслеживания загрузки воспроизведения
    playError: null, // Для ошибок воспроизведения
};

const advertisementsSlice = createSlice({
    name: 'advertisements',
    initialState,
    reducers: {
        resetAdvertisementsState: (state) => {
            state.advertisements = null;
            state.media = {};
            state.loading = false;
            state.error = null;
            state.playLoading = false;
            state.playError = null;
        },
        setAdMedia: (state, action) => {
            state.media = action.payload || {};
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch advertisements. Прежний список держим, пока идёт перезапрос и
            // если он упал: реклама нужна и на экране печати, и обнулять её из-за
            // одного неудачного опроса незачем.
            .addCase(fetchAdvertisements.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdvertisements.fulfilled, (state, action) => {
                state.loading = false;
                state.advertisements = action.payload;
                state.error = null;
            })
            .addCase(fetchAdvertisements.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Create advertisement play
            .addCase(createAdvertisementPlay.pending, (state) => {
                state.playLoading = true;
                state.playError = null;
            })
            .addCase(createAdvertisementPlay.fulfilled, (state) => {
                state.playLoading = false;
                state.playError = null;
            })
            .addCase(createAdvertisementPlay.rejected, (state, action) => {
                state.playLoading = false;
                state.playError = action.payload;
            });
    },
});

export const { resetAdvertisementsState, setAdMedia } = advertisementsSlice.actions;
export default advertisementsSlice.reducer;
